import React, { useState } from "react";
import { Row, Col, Container, CardImg, Card } from "reactstrap";
import MyModal from "../../helpers/MyModal";

import ccaData from "../../../assets/images/CCA 2026 - Comparing data collection results.JPG";
import ccaLake from "../../../assets/images/CCA 2026 - Jessica at the lake.JPG";
import ccaLab from "../../../assets/images/CCA 2026 - Lab.jpg";
import cca1 from "../../../assets/images/CCA 1.JPG";
import cca2 from "../../../assets/images/CCA 2.JPG";
import cca3 from "../../../assets/images/CCA 3.JPG";
import cca4 from "../../../assets/images/CCA 4.JPG";

const atLake = [
  {
    src: ccaData,
    title: "Change Agents compare their data collection results at the lake",
  },
  {
    src: ccaLake,
    title: "Jessica at the lake",
  },
  {
    src: cca1,
    title:
      "A Change Agent deploys a data collection device at the reservoir's edge",
  },
  {
    src: cca2,
    title:
      "Hydrologist Sol Henderson explains how reservoir chemistry leads to methane",
  },
  {
    src: cca3,
    title: "The group gathers at the reservoir shoreline",
  },
  {
    src: cca4,
    title: "The Climate Change Agents together at the lake",
  },
];

const lab = [
  {
    src: ccaLab,
    title: "Change Agents observe the testing of the samples in the lab",
  },
];

const ClimateChangeAgents2026 = () => {
  const allImages = {
    atLake,
    lab,
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState({ src: "", title: "" });

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const showModalImage = (imageId, arrayName) => {
    const selectedArray = allImages[arrayName];
    if (selectedArray) {
      toggleModal();
      setCurrentIndex(selectedArray[imageId]);
    }
  };
  return (
    <Container>
      <MyModal
        currentIndex={currentIndex}
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
      />
      <Row>
        <Col
          sm="12"
          md={{
            offset: 1,
            size: 10,
          }}
        >
          <h1>
            <strong>Climate Change Agents Make Lifelong Commitment</strong>
          </h1>
        </Col>
        <Col
          sm="12"
          md={{
            offset: 1,
            size: 10,
          }}
        >
          <p>
            The Climate Change Agents completed their reunion project on July
            21, 2026, in Nevada County, California, headquartered at their
            beloved Papa Bear Lodge, the center of their summer camp initiatives
            since the first camp in 2014.
          </p>
          <p>
            Each year&rsquo;s themes culminated in this year&rsquo;s celebration
            of their role as &ldquo;Climate Change Agents for Life.&rdquo;
            Pondering their long-term commitment to improving life for all
            created beings, they discussed the growth of seedlings into
            pinecones and, ultimately, into mature trees. This metaphor mirrored
            the impact of community-service initiatives based on their annual
            habit-of-heart themes, which have not only spurred their own growth,
            inspired their collaborations, and shaped their perspectives, but
            have also generated positive impacts for humankind and for other
            species.
          </p>
          <p>
            Each year, the Climate Change Agents have tackled a specific
            habit-of-heart and climate-related environmental research and
            advocacy challenge. In 2026, they considered an often-overlooked
            question: What diminishes a reservoir&rsquo;s predominant value as a
            carbon sink and water storage container? (A reservoir can interrupt
            ecosystems, displace human communities, and emit an abundance of
            greenhouse gas (especially methane), mostly through the algae blooms
            that occur in stagnant water.)
          </p>
          <p>
            In three teams, the group used several methods to collect visual
            data on the presence of methane in a local reservoir. They also
            reviewed the equipment often used to check water quality, to
            identify their most appropriate data collection tools. A hydrologist
            from Sierra Streams Institute, Sol Henderson, then arrived as a
            guest. He distributed three different data collection devices used
            to further check for high levels of nitrate and phosphate, which
            contribute to the excessive growth of algae and other organic
            material in an aquatic ecosystem.
          </p>
          <p>
            The group went on to the lab to observe the testing of the samples.
            Next, they made explanatory videos for NASA, encouraging a lead
            researcher to continue using satellites to watch for algae plumes
            and to advocate for global attention to methane emissions in
            community reservoirs.
          </p>
          <p>
            The Change Agents also reminisced about their most meaningful
            initiatives over the past 12 years. They sent their thoughts to Yale
            Climate Connections, to thank the outgoing co-founder for
            publicizing their past efforts and also to congratulate the
            university program for prioritizing service to the planet.
          </p>
          <p>
            By the end of the experience, the group also completed their annual
            shopping and cooking challenge, with each team selecting its menu
            items based on criteria such as biodegradable packaging, low
            transportation miles, and limited water use. They celebrated the
            habits-of-heart exhibited by their peers by passing around their
            journals. Each team member praised the qualities they appreciated in
            each of the others.
          </p>
          <p>
            The Change Agents vowed to keep their friendship and collaboration
            strong as they parted to pursue their separate journeys, with some
            completing high school or college and others launching
            service-oriented careers focused on positive change. May they always
            remember their commitment to act on behalf of living beings.
          </p>
        </Col>
        <Col
          sm="12"
          md={{
            offset: 1,
            size: 10,
          }}
        >
          <h2>
            <strong>At the Lake</strong>
          </h2>
        </Col>
        <Col
          sm="12"
          md={{
            offset: 1,
            size: 10,
          }}
          className="muli-colmn-tw"
        >
          {atLake.map((image, index) => (
            <Card
              className="image-card"
              key={image.title}
              onClick={() => showModalImage(index, "atLake")}
              style={{ padding: "6px 0px" }}
            >
              <CardImg
                src={image.src}
                style={{ height: "400px", objectFit: "cover" }}
              />
            </Card>
          ))}
        </Col>
        <Col
          sm="12"
          md={{
            offset: 1,
            size: 10,
          }}
        >
          <h2>
            <strong>Lab</strong>
          </h2>
        </Col>
        <Col
          sm="12"
          md={{
            offset: 1,
            size: 10,
          }}
        >
          {lab.map((image, index) => (
            <Card
              className="image-card"
              key={image.title}
              onClick={() => showModalImage(index, "lab")}
              style={{ padding: "6px 0px", width: "50%" }}
            >
              <CardImg
                src={image.src}
                style={{ height: "400px", objectFit: "cover" }}
              />
            </Card>
          ))}
        </Col>
        <Col
          sm="12"
          md={{
            offset: 1,
            size: 10,
          }}
        >
          <p>
            <em>
              Project participants included alumni Finn, Erik, Asa, Logan, Taj
              and Jessie, teaming up with Teresa, Lily, Jonah, Sol, Helen, and
              Jax to complete the project.
            </em>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default ClimateChangeAgents2026;
